import React, { FC, useEffect, useState } from 'react'
import styled, { CSSProperties } from 'styled-components'

export interface ConnectorType {
  moveX?: number
  moveY?: number
  width?: number
  height?: number
  offset?: number
  type?: 'straight' | 'curved'
  style?: CSSProperties
}

export const Connector: FC<Required<ConnectorType>> = ({
  moveX,
  moveY,
  width,
  height,
  offset,
  type = 'straight',
  style,
}) => {
  const svgWidth = Math.abs(width)
  const svgHeight = Math.abs(height)

  console.log(width, svgWidth)
  const direction = 'right'

  const anchorVert = height === 0 ? '' : height > 0 ? 'bottom' : 'top'
  const anchorHori = width === 0 ? '' : width > 0 ? 'right' : 'left'
  const anchor = anchorVert + '-' + anchorHori

  const arrowBase = 10

  const p1 = [0, 0]
  const p4 = [width, height]

  const a1 = [width, 0]
  const a1_c = [0, height]

  const p2 = anchor.includes('-left') ? [-arrowBase, 0] : [arrowBase, 0]
  const p2_c = anchor.includes('top') ? [0, -arrowBase] : [0, arrowBase]

  const p3 = anchor.includes('top')
    ? [width, height + arrowBase]
    : [width, height - arrowBase]
  const p3_c = anchor.includes('-left')
    ? [width + arrowBase, height]
    : [width - arrowBase, height]

  // top-left
  const tl =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2[0]},${p2[1]}` +
    `S ${a1[0]},${a1[1]} ${p3[0]},${p3[1]}` +
    `L ${p4[0]},${p4[1]}`

  const tl_counter =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2_c[0]},${p2_c[1]}` +
    `S ${a1_c[0]},${a1_c[1]} ${p3_c[0]},${p3_c[1]}` +
    `L ${p4[0]},${p4[1]}`

  // bottom-left
  const bl =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2[0]},${p2[1]}` +
    `S ${a1[0]},${a1[1]} ${p3[0]},${p3[1]}` +
    `L ${p4[0]},${p4[1]}`

  const bl_counter =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2_c[0]},${p2_c[1]}` +
    `S ${a1_c[0]},${a1_c[1]} ${p3_c[0]},${p3_c[1]}` +
    `L ${p4[0]},${p4[1]}`

  // top-right
  const tr =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2[0]},${p2[1]}` +
    `S ${a1[0]},${a1[1]} ${p3[0]},${p3[1]} ` +
    `L ${p4[0]},${p4[1]}`

  const tr_counter =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2_c[0]},${p2_c[1]}` +
    `S ${a1_c[0]},${a1_c[1]} ${p3_c[0]},${p3_c[1]}` +
    `L ${p4[0]},${p4[1]}`

  // bottom-right
  const br =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2[0]},${p2[1]}` +
    `S ${a1[0]},${a1[1]} ${p3[0]},${p3[1]}` +
    `L ${p4[0]},${p4[1]}`

  const br_counter =
    `M ${p1[0]},${p1[1]}` +
    `L ${p2_c[0]},${p2_c[1]}` +
    `S ${a1_c[0]},${a1_c[1]} ${p3_c[0]},${p3_c[1]}` +
    `L ${p4[0]},${p4[1]}`

  return (
    <ConnectorRoot
      {...{ moveX, moveY }}
      width={Math.max(1, Math.abs(width))}
      height={Math.max(1, Math.abs(height))}
      viewBox={`0 0 ${Math.max(1, Math.abs(width))} ${Math.max(1, Math.abs(height))}`}
    >
      <defs>
        <marker
          id='triangle'
          viewBox='-2 0 12 10'
          refX='1'
          refY='5'
          markerUnits='strokeWidth'
          markerWidth={Math.abs(arrowBase)}
          markerHeight={Math.abs(arrowBase)}
          orient='auto'
        >
          <path d='M 10 0 L 0 5 L 10 10 z' fill={style.stroke || '#202346'} />
        </marker>
      </defs>
      {/* {type === 'straight' && (
        <line x1={x1} y1={y1} x2={x2} y2={y2} style={style} />
      )} */}
      {type === 'straight' && (
        <>
          <line
            x1={0}
            y1={0}
            x2={
              svgWidth +
              (anchor.includes('right')
                ? -10
                : anchor.includes('left')
                ? 10
                : 0)
            }
            y2={svgHeight}
            style={style}
          />
        </>
      )}
      {type === 'curved' && (
        <>
          <path
            d={
              anchor === 'bottom-left'
                ? bl
                : anchor === 'bottom-right'
                ? br
                : anchor === 'top-left'
                ? tl
                : tr
            }
            style={style}
            fill='none'
            markerStart='url(#triangle)'
          />
          {/* <path
            d={
              anchor === 'bottom-left'
                ? bl_counter
                : anchor === 'bottom-right'
                ? br_counter
                : anchor === 'top-left'
                ? tl_counter
                : tr_counter
            }
            style={style}
            fill='none'
            markerStart='url(#triangle)'
          /> */}
        </>
      )}
    </ConnectorRoot>
  )
}

/*
  S ${x2},${y1} ${x2},${y2}



*/

const ConnectorRoot = styled.svg<{
  moveX: number
  moveY: number
  width: number
  height: number
}>`
  overflow: visible;
  height: ${({ height }) => Math.abs(height) + 'px'};
  width: ${({ width }) => Math.abs(width) + 'px'};
  position: absolute;
  top: 0;
  transform: ${({ moveX, moveY }) =>
    `translate(${moveX + '%'},${moveY + '%'})`};
`
